<div class="form__group">
  <div class="form__label" [class.form__label_require]="require && !disabled">
    <ng-content></ng-content>
  </div>
  <textarea [id]="'area-' + id" [rows]="rows" [placeholder]="placeholder" [elementId]="'area-' + id"
            [appWysiwygEditor]="current_value" (value_emitter)="onWysiwygChange($event)"></textarea>
</div>
